
import Component from "vue-class-component"
import {QChip} from "quasar"
import {Prop, Inject} from "vue-property-decorator"
import ChangeRateWidget from "@/superannuation/ChangeRateWidget.vue"
import {MetricHistory} from "@/cube/metric-data"
import {SparklineChart} from "@/ui/chart/SparklineChart"
import {DateRange} from "@/DateRangeSelector"
import {DateRangeService} from "@/DateRangeService"
import {WithAnalyticsNavigation} from "@/superannuation/WithAnalyticsNavigation"
import {formatValue} from "@/utils/formatter"

@Component({components: {ChangeRateWidget, QChip}})
export default class MetricTrendWidget extends WithAnalyticsNavigation {
  @Prop({required: true})
  metricData: MetricHistory

  @Prop({default: true})
  showChange: boolean

  @Prop({default: true})
  showSparkline: boolean

  @Prop({default: false})
  downPositive: boolean

  @Inject()
  dateRangeService: DateRangeService

  sparkline?: SparklineChart

  get formattedValue() {
    return this.isReady
      ? formatValue(this.metricData.metric, this.metricData.end!.amount, true)
      : ""
  }

  get isReady() {
    return !!this.metricData.end
  }

  get title() {
    return this.metricData.title
  }

  mounted() {
    this.$watch(
      () => this.metricData.end?.amount,
      () => {
        if (this.showSparkline && this.metricData.end != null) {
          if (this.sparkline) {
            this.sparkline.dispose()
          }
          this.sparkline = new SparklineChart(
            <HTMLElement>this.$el.querySelector(".chart"),
            this.metricData,
            (dateRange: DateRange) =>
              (this.dateRangeService.dateRangeSelector!.selected = dateRange)
          )
        }
      },
      {immediate: true}
    )

    this.$watch(
      () => this.metricData.dateRange,
      () => {
        if (this.metricData.dateRange && this.sparkline) {
          this.sparkline.highlightSelectedRange(this.metricData.dateRange)
        }
      },
      {immediate: true}
    )
  }

  beforeDestroy() {
    if (this.sparkline) {
      this.sparkline.dispose()
    }
  }
}
